import { render, staticRenderFns } from "./SocialShareButton.vue?vue&type=template&id=8a76fc48&scoped=true&"
import script from "./SocialShareButton.vue?vue&type=script&lang=ts&"
export * from "./SocialShareButton.vue?vue&type=script&lang=ts&"
import style0 from "./SocialShareButton.vue?vue&type=style&index=0&id=8a76fc48&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a76fc48",
  null
  
)

export default component.exports